import React from "react";
import {
  Link,
  withRouter,
} from "react-router-dom";

const PaymentSuccess = ({ location }) => {
  let paymentIntentId = "";

  try {
    const query = new URLSearchParams(
      location.search || ""
    );

    paymentIntentId =
      query.get("payment_intent") || "";
  } catch (error) {
    console.error(
      "Unable to read payment reference:",
      error
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        padding: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        boxSizing: "border-box",
      }}
    >
      <div>
        <h1>Payment Successful</h1>

        <p>
          Stripe has confirmed your
          PromptPay payment.
        </p>

        {paymentIntentId && (
          <p>
            Payment reference:
            <br />

            <strong>
              {paymentIntentId}
            </strong>
          </p>
        )}

        <Link to="/">
          Return to home
        </Link>
      </div>
    </div>
  );
};

export default withRouter(
  PaymentSuccess
);
